// import React from 'react';

// const CustomButton = ({ children, style, className, onClick, disabled, variant, ...props }) => {
//     return (
//         <button
//             style={style}
//             className={`btn btn-${variant} ${className}`}
//             onClick={onClick}
//             disabled={disabled}
//             {...props}
//         >
//             {children}
//         </button>
//     );
// };

// export default CustomButton;


import React, { useState, useRef } from 'react';
import { Overlay, Tooltip } from 'react-bootstrap';

const CustomButton = ({
    children,
    style,
    className,
    onClick,
    disabled,
    variant,
    tooltipText, // Add tooltipText as a prop
    ...props
}) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const target = useRef(null); // Reference to button for positioning the tooltip

    return (
        <>
            <button
                ref={target}
                style={style}
                className={`btn btn-${variant} ${className}`}
                onClick={onClick}
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
                disabled={disabled}
                {...props}
            >
                {children}
            </button>

            {tooltipText && (
                <Overlay target={target.current} show={showTooltip} placement="top">
                    {(props) => (
                        <Tooltip id="overlay-tooltip" {...props}>
                            {tooltipText}
                        </Tooltip>
                    )}
                </Overlay>
            )}
        </>
    );
};

export default CustomButton;